import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/feature.png'


const _withScopeId = n => (_pushScopeId("data-v-2d656ea4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "feature" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "FEATURE"),
  /*#__PURE__*/_createElementVNode("h1", null, "Why choose us !")
], -1))
const _hoisted_3 = { class: "feature-box" }
const _hoisted_4 = { class: "features" }
const _hoisted_5 = { class: "features-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-topic" }, " \" แผ่นใยสังเคราะห์ “จีโอเทกไทล์”ชนิดไม่ถักทอ \" ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-topic" }, " ผลิตภัณฑ์ของ บริษัท ทีที เอ็กซ์คลูซีฟ จำกัด ใช้กระบวนการผลิตแบบเข็มปัก จากเส้นใยโพลีเอสเตอร์/โพลีพร็อพพีลีน โดยเครื่องจักรที่ทันสมัย และโรงงานที่ได้มาตรฐาน โดยคำนึงถึงคุณภาพ เพื่อประสิทธิภาพในการใช้งานโดยรวมที่ให้ประโยชน์สูงสุด ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-topic" }, " Geotextile คือ แผ่นใยสังเคราะห์ ที่ออกแบบมาเพื่อใช้ในการแก้ปัญหาที่เหมาะสมกับงานวิศวกรรมทางชลศาสตร์และโยธา มีความสามารถในการระบายน้ำได้สูง, รับแรงกระแทก มีคุณสมบัติในการยืดหยุ่นตัวได้ดีและฉีกขาดยาก อีกทั้งยังเหมาะกับการใช้งานในการเสริมความแข็งแรง เสริมความมั่นคง และเสถียรภาพดิน ", -1))
const _hoisted_9 = { class: "sub-topic" }
const _hoisted_10 = { class: "list-topic" }
const _hoisted_11 = { class: "ps-md-0" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "features-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "feature"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_box_icon = _resolveComponent("box-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createTextVNode(" หน้าที่หลักมีดังนี้ : "),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("ul", _hoisted_11, [
                _createElementVNode("li", null, [
                  _createVNode(_component_box_icon, {
                    name: "check",
                    size: "30px",
                    color: "#009688"
                  }),
                  _createTextVNode("แยกชั้นของวัสดุ")
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_box_icon, {
                    name: "check",
                    size: "30px",
                    color: "#009688"
                  }),
                  _createTextVNode("ป้องกันดิน")
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_box_icon, {
                    name: "check",
                    size: "30px",
                    color: "#009688"
                  }),
                  _createTextVNode("ควบคุมการทรุดตัวของชั้นดิน")
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_box_icon, {
                    name: "check",
                    size: "30px",
                    color: "#009688"
                  }),
                  _createTextVNode("ชั้นกรองวัสดุ")
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_box_icon, {
                    name: "check",
                    size: "30px",
                    color: "#009688"
                  }),
                  _createTextVNode("เสริมกำลังดินในทางลาดชัน และกำแพงดิน")
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_box_icon, {
                    name: "check",
                    size: "30px",
                    color: "#009688"
                  }),
                  _createTextVNode("ใช้เป็นโครงสร้างในการยึดเกาะตัว , ป้องกันการฉีกขาด ของงานเคมีกันซึม")
                ])
              ])
            ])
          ])
        ])
      ]),
      _hoisted_12
    ])
  ]))
}